import React, {Component} from 'react';
import GridItem from "../GridItem/GridItem";
import Filters from "../Filters/Filters";
import URI from "urijs";
import MapMarker from "../MapMarker/MapMarker";
import StormarnLauenburgMap from "../StormarnLauenburgMap/StormarnLauenburgMap";

const STATUS_ACTIVE = 'active';
const STATUS_ALL = 'all';
const STATUS_YEAR_PREFIX = 'year-';

const parseLocation = (location) => {
    const params = URI.parseQuery(location);
    return params;
}

const isTruthyAttr = (value) => value === true || value === 1 || value === '1';

const isMissing = (value) => value === undefined || value === null;

const hasPosition = (item) => item.latitude !== 0 && item.latitude !== '0';

// Combined status filter: currently active places, everyone, or everyone who
// took part in a given year – active artists included, since they take part in
// the current year as well.
const matchesStatus = (item, status) => {
    if (status === STATUS_ACTIVE) {
        // Cached markup from before the status feature carries no isactive
        // attribute – keep those items visible instead of emptying the list.
        return isMissing(item.isactive) || isTruthyAttr(item.isactive);
    }

    if (status.indexOf(STATUS_YEAR_PREFIX) === 0) {
        if (isMissing(item.years)) {
            return true;
        }

        const year = status.substring(STATUS_YEAR_PREFIX.length);
        return item.years.split(',').filter(Boolean).indexOf(year) !== -1;
    }

    // STATUS_ALL and anything unknown
    return true;
}

// One predicate per filter id. `city` doubles as the map drill-down, so it
// applies even on pages that offer no filter dropdowns at all.
const PREDICATES = {
    city: (item, value) => value === item.topline,
    group: (item, value) => String(value) === String(item.groupid),
    direction: (item, value) => (item.directions || '').split(',').indexOf(String(value)) !== -1,
    status: matchesStatus,
};

const matchesQuery = (item, values, exceptId) =>
    Object.keys(values).every((id) =>
        id === exceptId || !values[id] || !PREDICATES[id] || PREDICATES[id](item, values[id])
    );

// A filter option survives when at least one item that passes the other
// filters would still match it – so picking a city also drops the years and
// groups that city never took part in. The current selection always stays, so
// the control never renders blank.
const narrowFilter = (filter, items, values) => {
    const predicate = PREDICATES[filter.id];
    if (!predicate) {
        return filter;
    }

    const candidates = items.filter(item => matchesQuery(item, values, filter.id));
    const selected = String(values[filter.id] || '');

    return Object.assign({}, filter, {
        values: filter.values.filter(value =>
            String(value.ID) === selected
            || candidates.some(item => predicate(item, String(value.ID)))
        ),
    });
};

class KunstOrteList extends Component {
    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.hashChange = this.hashChange.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        const location = window.location.hash.replace(/^#\/?|\/$/g, '');
        this.state = {
            query: parseLocation(location)
        };
    }

    hashChange() {
        const location = window.location.hash.replace(/^#\/?|\/$/g, '');
        this.setState({
            query: parseLocation(location)
        });
    }

    componentDidMount() {
        window.addEventListener("hashchange", this.hashChange, false);
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.hashChange, false);
    }

    navigate(change) {
        const query = Object.assign(this.state.query, change);
        window.location.href =
            window.location.pathname + window.location.search + '#' + URI.buildQuery(query)
        ;
        // this.setState({query: query});
    }

    // Clears every filter; an empty status falls back to its configured default.
    resetFilters() {
        this.navigate({city: '', group: '', direction: '', status: ''});
    }

    render() {
        const {items} = this.props;
        const filters = this.props.filters || [];

        const {query} = this.state;

        const statusFilter = filters.find(filter => filter.id === 'status');
        const values = {
            city: query.city || '',
            group: query.group || '',
            direction: query.direction || '',
            status: query.status || (statusFilter && statusFilter.default) || '',
        };

        const locatedItems = items.filter(hasPosition);
        const filteredItems = locatedItems.filter(item => matchesQuery(item, values, null));

        const narrowedFilters = filters.map(filter => narrowFilter(filter, locatedItems, values));

        const defaultStatus = (statusFilter && statusFilter.default) || '';
        const isFiltered = Boolean(values.city || values.group || values.direction || values.status !== defaultStatus);

        let mapItems = [];

        if(query.city) {
            const itemMap = filteredItems.reduce((result, item) => {
                if(!result[item.latitude + '/' + item.longitude]) {
                    result[item.latitude + '/' + item.longitude] = Object.assign({
                        icon: 'person',
                        content: '<a href="'+item.href+'">'+item.headline+'</a>'
                    }, item)
                } else {
                    result[item.latitude + '/' + item.longitude].icon = 'people';
                    result[item.latitude + '/' + item.longitude].content += '<br/>' + '<a href="'+item.href+'">'+item.headline+'</a>';
                }

                return result;
            }, {});
            mapItems = Object.values(itemMap);
            //Group
        } else {
            const cityMap = filteredItems.reduce((result, item) => {
                result[item.topline] = {
                    content: item.topline,
                    icon: null,
                    longitude: item.longitude,
                    latitude: item.latitude,
                    number: (result[item.topline] ? result[item.topline].number + 1 : 1),
                };
                return result;
            }, {});
            mapItems = Object.values(cityMap);
        }

        return (
            <>
                <section className="stage section section--KunstOrteFilter">
                    <div className="map section_content">
                        <StormarnLauenburgMap
                          items={filteredItems}
                          zoom={14}
                        >
                            {mapItems.map(item => (
                                <MapMarker
                                    position={[
                                        parseFloat(item.latitude),
                                        parseFloat(item.longitude)
                                    ]}
                                    onClick={(e) => {
                                        if(query.city) {
                                            // window.location.href=item.href;
                                            return;
                                        }

                                        this.navigate({city: item.content});
                                    }}
                                    hover={!query.city}
                                    icon={item.icon}
                                    content={query.city ? '' : item.number}
                                >
                                    {item.content}
                                </MapMarker>
                            ))}
                        </StormarnLauenburgMap>
                        { narrowedFilters.length || isFiltered ? <div className="header_filter">
                            { narrowedFilters.length
                                ? <Filters navigate={this.navigate} query={query} filters={narrowedFilters}/>
                                : null }
                            { isFiltered ? <div
                                className="header_filter_reset"
                                role="button"
                                tabIndex={0}
                                onClick={this.resetFilters}
                                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && this.resetFilters()}
                            >
                                Filter zurücksetzen
                            </div> : null }
                        </div> : null }
                    </div>
                </section>
                <section className="section section--KunstOrte">
                    <div className="section_content">
                        <div className="grid_list">
                            {filteredItems.map(item => <GridItem {...item}/>)}
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default KunstOrteList;
